function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
  fill: "#F0F2FA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2265 29.9928C16.0331 29.9275 15.8618 29.8094 15.732 29.6519C15.5486 29.4293 15.4578 29.1447 15.4782 28.857C15.4986 28.5693 15.6288 28.3004 15.8418 28.1059C16.0654 27.9122 21.3579 23.4837 26.753 24.3136C29.3629 24.7188 31.5277 26.2561 33.1907 28.8589C33.2699 28.9838 33.3236 29.1232 33.3486 29.269C33.3736 29.4148 33.3695 29.5641 33.3363 29.7083C33.3032 29.8525 33.2417 29.9886 33.1555 30.1089C33.0693 30.2291 32.9601 30.3311 32.8342 30.4088C32.5814 30.5669 32.2762 30.6182 31.9855 30.5513C31.6949 30.4845 31.4427 30.305 31.2844 30.0523C29.9989 27.9963 28.3595 26.8024 26.4252 26.5063C22.0494 25.8222 17.3634 29.743 17.323 29.7689C17.1753 29.898 16.9966 29.9865 16.8044 30.0257C16.6122 30.065 16.413 30.0536 16.2265 29.9928Z",
  fill: "#676F8F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18 19.875C19.3462 19.875 20.4375 18.7837 20.4375 17.4375C20.4375 16.0913 19.3462 15 18 15C16.6538 15 15.5625 16.0913 15.5625 17.4375C15.5625 18.7837 16.6538 19.875 18 19.875Z",
  fill: "#676F8F"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30 19.875C31.3462 19.875 32.4375 18.7837 32.4375 17.4375C32.4375 16.0913 31.3462 15 30 15C28.6538 15 27.5625 16.0913 27.5625 17.4375C27.5625 18.7837 28.6538 19.875 30 19.875Z",
  fill: "#676F8F"
});

var SvgFace2Disabled = function SvgFace2Disabled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFace2Disabled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/face2_disabled.165196f7.svg";
export { ForwardRef as ReactComponent };